<fa-icon
  [icon]="['fas', 'times-circle']"
  class="grid-detail-pane__close"
  (click)="close()"
></fa-icon>

<div class="grid-detail-pane__head">
  <ng-content select="[paneHeader]"></ng-content>
</div>

@if (tabs().length) {
  <ul class="nav nav-tabs">
    @for (tab of tabs(); track tab.id) {
      <li class="nav-item">
        <a
          class="nav-link"
          [class.active]="activeTab() === tab.id"
          (click)="activeTab.set(tab.id)"
        >
          {{ tab.labelKey | translate }}
        </a>
      </li>
    }
  </ul>
}

<ng-content></ng-content>
